module.exports = __webpack_public_path__ + "static/cgi-5636e02684813c333263e23088bd1064.jpg";